import React, { useContext, useEffect, useState } from "react";
import * as Styled from "./Styles";
import { toast } from "react-toastify";
import { useQueryString } from "../../../hooks/use-query-string";
import { AppConfigsContext } from "../../app-configs-context";
import CookieBox from "../../ui/cookie-box";
import SvgHamburger from "../../ui/icons/hamburger";
import Depositions from "./Depositions";
import ContentFooter from "./footer/content";
import Login from "./login";
import "./login_or_register.css.scss";
import Register from "./register";
import LogoBlue from "../../../images/logo-blue-gray-side.png";
import LogoWhite from "../../../images/logo-white.png";

type AppConfigs = {
  contact?: {
    whatsapp?: string;
  };
};

const LoginOrRegister = () => {
  const { query } = useQueryString();
  const [isNavExpanded, setIsNavExpanded] = useState(false);

  const [activeTab, setActiveTab] = useState(
    query.get("invitation_token") ? "register" : "login"
  );
  const login = activeTab === "login";

  useEffect(() => {
    query.get("account_confirmation_success") === "true" &&
      toast.success("Sua conta foi confirmada com sucesso!");
  }, [query]);

  const appConfigs = useContext<AppConfigs>(AppConfigsContext);

  return (
    <>
      <Styled.Navbar>
        <a href="https://www.mercatorio.com.br" target="_blank">
          <img src={LogoBlue} alt="Logo" />
        </a>

        <Styled.Menu onClick={() => setIsNavExpanded(!isNavExpanded)}>
          <SvgHamburger />
        </Styled.Menu>

        <Styled.ButtonsWrapper expanded={isNavExpanded}>
          <a href="https://blog.mercatorio.com.br" target="_blank">
            Blog
          </a>
          <a href={appConfigs?.contact?.whatsapp} target="_blank">
            Entre em contato
          </a>
        </Styled.ButtonsWrapper>
      </Styled.Navbar>

      <Styled.LoginRegisterSection>
        <Styled.LoginRegisterSectionContent>
          <Styled.LoginRegisterForm>
            <h1>Plataforma de investimentos em precatórios</h1>

            <Styled.Greetings>
              <img src={LogoWhite} alt="Logo" />

              <div>
                <span>{login ? "Bem-vindo de volta!" : "Novo por aqui?"}</span>

                {login
                  ? "Faça o login para continuar"
                  : "Cadastre-se para continuar"}
              </div>
            </Styled.Greetings>

            <Styled.Tabs>
              <Styled.Tab onClick={() => setActiveTab("login")} active={login}>
                Entrar
              </Styled.Tab>

              <Styled.Tab
                onClick={() => setActiveTab("register")}
                active={!login}
              >
                Cadastrar
              </Styled.Tab>
            </Styled.Tabs>

            {login ? <Login /> : <Register />}
          </Styled.LoginRegisterForm>
        </Styled.LoginRegisterSectionContent>
      </Styled.LoginRegisterSection>

      <Depositions />
      <ContentFooter />
      <CookieBox />
    </>
  );
};

export default LoginOrRegister;
